import React, { FC, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import cn from 'classnames';
import { AppBundle } from 'api/optimalprint-sdk.d';
import styles from './StudioFrameSelector.module.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';

export interface StudioFrameSelectorProps {
  frames: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem[];
  activeFrameProductId: number | undefined;
  frameTitle: string | undefined;
  frameDescription: string | null | undefined;
  selectFrameCallback: (
    frame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem,
    frameIndex: number,
  ) => void;
}

const StudioFrameSelector: FC<StudioFrameSelectorProps> = ({
  activeFrameProductId,
  frameDescription,
  frameTitle,
  frames,
  selectFrameCallback,
}) => {
  const selectFrame = (
    frame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem,
    frameIndex: number,
  ) => {
    selectFrameCallback(frame, frameIndex);
  };

  // preselect first frame option
  useEffect(() => {
    const firstFrameOptionIndex = frames.findIndex((option) => option.productId > 0);
    if (firstFrameOptionIndex >= -1) {
      selectFrame(frames[firstFrameOptionIndex], firstFrameOptionIndex);
    }
  }, []);

  return (
    <div className={styles.frameSelector}>
      <PerfectScrollbar className={styles.selectorArea}>
        {frames.map((frame, index) => {
          return (
            <div
              key={`fr${index}`}
              className={cn(styles.frame, {
                [styles.active]: activeFrameProductId === frame.productId,
              })}
              onClick={() => selectFrame(frame, index)}
            >
              {frame.thumbnailUrl && <img src={frame.thumbnailUrl} alt="" />}
              {!frame.thumbnailUrl && <span>{frame.name}</span>}
            </div>
          );
        })}
      </PerfectScrollbar>
      <div className={styles.frameTitle}>{frameTitle}</div>
      <div className={styles.frameDescription}>{frameDescription}</div>
    </div>
  );
};

export default StudioFrameSelector;
